import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Quests from "@/pages/Quests";
import Workouts from "@/pages/Workouts";
import Metrics from "@/pages/Metrics";
import Journal from "@/pages/Journal";
import Photos from "@/pages/Photos";
import Lesson from "@/pages/Lesson";
import TimerPage from "@/pages/Timer";
import Analytics from "@/pages/Analytics";
import Achievements from "@/pages/Achievements";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Shell><Dashboard /></Shell>} />
          <Route path="/quests" element={<Shell><Quests /></Shell>} />
          <Route path="/workouts" element={<Shell><Workouts /></Shell>} />
          <Route path="/metrics" element={<Shell><Metrics /></Shell>} />
          <Route path="/journal" element={<Shell><Journal /></Shell>} />
          <Route path="/photos" element={<Shell><Photos /></Shell>} />
          <Route path="/lesson" element={<Shell><Lesson /></Shell>} />
          <Route path="/timer" element={<Shell><TimerPage /></Shell>} />
          <Route path="/analytics" element={<Shell><Analytics /></Shell>} />
          <Route path="/achievements" element={<Shell><Achievements /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
